module.exports = __webpack_public_path__ + "img/img_logo@2x.d05cb15c.png";